import React from 'react'
import PropTypes from 'prop-types'
import './index.css'

export default function Logo({ text, className, url, ...rest }) {
  const classes = `pypl-logo ${className}`

  return (
    <a
      {...rest}
      className={classes}
      style={{ backgroundImage: url ? `url(${url})` : '' }}
    >
      {text}
    </a>
  )
}

Logo.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
  url: PropTypes.string,
}
